<template>
  <div class="mypage">
    <InformationComponent class="mb-3"/>
    <LessonComponent class="mb-3"/>
    <ToDoApplicationComponent class="mb-3"/>
    <ToDoDeadlineComponent class="mb-3"/>
    <div class="d-flex flex-wrap">
      <div class="w-25 mb-3">
        <router-link
          :to="{
            name: 'ClockIns',
            params: {
              date: today.format('YYYYMMDD'),
            },
          }"
          class="common__dashboard_link"
        >
          Clock-in
        </router-link>
      </div>
      <div class="w-25 mb-3">
        <router-link
          :to="{name: 'UnfinishedTasks'}"
          class="common__dashboard_link"
        >
          Unfinished Tasks
        </router-link>
      </div>
      <div class="w-25 mb-3">
        <router-link
          :to="{name: 'tutorSendMails'}"
          class="common__dashboard_link"
        >
          Mail Tutors
        </router-link>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="w-25 mb-3">
        <a
          class="common__dashboard_link"
          href="https://led.w-as.jp/data/te/2021-te-lesson-calender.pdf"
          rel="noreferrer"
          target="_blank"
        >
          <img src="@/assets/AnnualSchedule.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import moment, { Moment } from 'moment'
import LessonComponent from '@/components/parts/mypage/LessonComponent.vue';
import ToDoApplicationComponent from '@/components/parts/mypage/ToDoApplicationComponent.vue';
import ToDoDeadlineComponent from '@/components/parts/mypage/ToDoDeadlineComponent.vue';
import InformationComponent from '@/components/parts/mypage/InformationComponent.vue';

export default Vue.extend({
  components: {
    LessonComponent,
    InformationComponent,
    ToDoApplicationComponent,
    ToDoDeadlineComponent,
  },

  computed: {
    today: (): Moment => moment(),
  },
})
</script>
